module.exports = __webpack_public_path__ + "img/re_IMG_1231.b1d4f9c1.jpeg";